import { FC } from 'react'

import { GridPairs } from '@builddocs/mui'
import { useDisclosure } from '@builddocs/system'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  Paper,
  Stack,
  Box,
} from '@mui/material'
import Draggable from 'react-draggable'

function PaperComponent(props) {
  return (
    <Draggable
      cancel={'[class*="MuiDialogContent-root"]'}
      handle="#draggable-feedback-dialog-title"
    >
      <Paper {...props} />
    </Draggable>
  )
}

type OwnProps = {
  mode?: 'icon' | undefined
}

const Feedback: FC<OwnProps> = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Box>
      <Link
        color="text.primary"
        sx={{ cursor: 'pointer' }}
        underline="hover"
        onClick={onOpen}
      >
        Обратная связь
      </Link>
      <Dialog
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-feedback-dialog-title"
        id="feedback-dialog"
        maxWidth="sm"
        open={isOpen}
        onClose={onClose}
      >
        <DialogTitle
          id="draggable-feedback-dialog-title"
          style={{ cursor: 'move' }}
        >
          Обратная связь
        </DialogTitle>
        <DialogContent>
          <DialogContentText mb={2}>
            По вопросам связанным с использованием сервиса можно обращаться по
            нашим каналам связи
          </DialogContentText>
          <Stack spacing={1}>
            <GridPairs
              isBlack
              content={[
                [
                  'Позвонить',
                  <Link
                    key="Позвонить"
                    href="tel:+79313376642"
                    underline="none"
                    target="_blank"
                  >
                    +79313376642
                  </Link>,
                ],
                [
                  'Написать',
                  <Link
                    key="Написать"
                    href="mailto:help@builddocs.ru"
                    underline="none"
                    target="_blank"
                  >
                    help@builddocs.ru
                  </Link>,
                ],
                [
                  'Написать в Телеграмм',
                  <Link
                    key="Написать"
                    href="https://t.me/BuildDocs_support"
                    underline="none"
                    target="_blank"
                  >
                    @BuildDocs_support
                  </Link>,
                ]
              ]}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={onClose}>
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default Feedback
